import { useEffect, useRef, useState } from "react";
import axiosInstance from "../../utilities/Axios";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Formik } from "formik";
import * as Yup from "yup";
import { EDialogAction } from "../Enum/DialogActionEnum";
import { useSnackbar } from "notistack";
import { Button, TextField } from "@mui/material";

const SubAgentDialogBox = (props: {
  open: boolean;
  onClose: any;
  data: any;
  dialogAction: EDialogAction;
}) => {
  const [subAgent, setSubAgent] = useState(props.data);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const formRef = useRef<any>();

  useEffect(() => {
    setSubAgent(props.data);
  }, [props.data]);

  const handleClose = (action: string = "closed") => {
    props.onClose(action);
  };

  const createSubAgent = async (data: any) => {
    try {
      const url = `${process.env.REACT_APP_API_ORIGIN}/v1/sub-agents`;

      const res = await axiosInstance.post(url, {
        name: data.name,
        contact_no: data.contact_no,
      });
      enqueueSnackbar("Sub Agent Created Successfully!!!!", {
        variant: "success",
      });
      handleClose("created");

    } catch (err: any) {
      enqueueSnackbar(
        `Sub Agent Creation Unsuccessful!!!! ${err.response.data.error}`,
        {
          variant: "error",
        }
      );
      console.error(err);
    }
  };
  const editSubAgent = async (data: any) => {

    const url = `${process.env.REACT_APP_API_ORIGIN}/v1/sub-agents/${subAgent.id}`;

    axiosInstance
      .put(url, {
        name: data.name,
        contact_no: data.contact_no,
      })
      .then((response) => {
        enqueueSnackbar("Sub Agent Updated Successfully!!!!", {
          variant: "success",
        });
      })
      .catch((err: any) => {
        enqueueSnackbar(
          `Sub Agent Updatation Unsuccessfull!!!! ${err.response.data.error}`,
          {
            variant: "error",
          }
        );
      });


    handleClose();
  };

  return (
    <>
      {" "}
      {subAgent == null ? (
        <div></div>
      ) : (
        <Dialog
          open={props.open}
          onClose={(event, reason) => {
            if (reason != "backdropClick" && reason != "escapeKeyDown") {
              handleClose();
            }
          }}
        >
          {props.dialogAction == EDialogAction.edit ? (
            <DialogTitle>Edit Sub-Agent :{props.data.id}</DialogTitle>
          ) : (
            <></>
          )}
          {props.dialogAction == EDialogAction.create ? (
            <DialogTitle>Create Sub-Agent </DialogTitle>
          ) : (
            <></>
          )}
          {props.dialogAction == EDialogAction.view ? (
            <DialogTitle>View Sub-Agent :{props.data.id}</DialogTitle>
          ) : (
            <></>
          )}
          <DialogContent>
            <Formik
              enableReinitialize
              validateOnMount
              initialValues={
                props.dialogAction == EDialogAction.create
                  ? {
                    name: "",
                    contact_no: "",
                  }
                  : subAgent
              }
              initialTouched={{ zip: true }}
              validationSchema={Yup.object().shape({
                name: Yup.string()
                  .required("Name is Required")
                  .max(85, "Name must not be greater than 85 characters"),

                contact_no: Yup.string()
                  .max(
                    15,
                    "Contact Number must not be greater than 15 characters"
                  )
                  .required("Contact Number is Required"),
              })}
              onSubmit={
                props.dialogAction == EDialogAction.create
                  ? createSubAgent
                  : editSubAgent
              }
              innerRef={formRef}
            >
              {({
                handleChange,
                handleBlur,
                handleSubmit,
                values,
                touched,
                errors,
              }) => (
                <div className="grid grid-cols-2 ">
                  <div className="flex flex-col space-y-1 mr-6 mb-4 mt-2">
                    <TextField
                      disabled={props.dialogAction == EDialogAction.view}
                      id="outlined-multiline-flexible"
                      label="Name"
                      variant="outlined"
                      onChange={handleChange}
                      value={values.name || ""}
                      placeholder="Enter Name"
                      name="name"
                      required
                      error={Boolean(errors.name && touched.name)}
                      helperText={
                        errors.name && touched.name && String(errors.name)
                      }
                    />
                  </div>
                  <div className="flex flex-col space-y-1 mr-6 mb-4 mt-2">
                    <TextField
                      disabled={props.dialogAction == EDialogAction.view}
                      id="contact_no"
                      variant="outlined"
                      onChange={handleChange}
                      value={values.contact_no || ""}
                      placeholder="Enter Contact Number"
                      name="contact_no"
                      required
                      label="Contact Number"
                      error={Boolean(errors.contact_no && touched.contact_no)}
                      helperText={
                        errors.contact_no &&
                        touched.contact_no &&
                        String(errors.contact_no)
                      }
                    />
                  </div>

                  <div>
                    <div className="flex space-x-2">
                      {props.dialogAction != EDialogAction.view ? (
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={() => {
                            handleSubmit();
                          }}
                        >
                          {props.dialogAction == EDialogAction.edit ? "Update" : "Create"}
                        </Button>
                      ) : null}
                      <Button
                        variant="contained"
                        color="secondary"
                        onClick={() => {
                          handleClose();
                        }}
                      >
                        Close
                      </Button>
                    </div>
                  </div>
                </div>
              )}
            </Formik>
          </DialogContent>
        </Dialog>
      )}
    </>
  );
};

export default SubAgentDialogBox;
